<template>
    <div class="row">
        <div class="col-12">
          <div class="card-header-actions">
            <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
              <button class="all-btn add-btn pull-right" @click="showEmploymentCoefficientFieldModal(null)">{{$t("action.add")}}</button>
            </div>
          </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                      <tr>
                          <th>#</th>
                          <th>Код</th>
                          <th>Текст</th>
                          <th>Текст(ru)</th>
                          <th>Актив</th>
                          <th>Парент</th>
                          <th class="text-center">{{$t("realEstate.field.action")}}</th>
                      </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                      <tr v-for="result in results.data" :key="result.id">
                          <td>{{result.id}}</td>
                          <td>{{result.code}}</td>
                          <td>{{result.name}}</td>
                          <td>{{result.nameRu}}</td>
                          <td>{{result.visibleState}}</td>
                          <td>{{result.parent ? result.parent.name : ''}}</td>
                          <td class="td-actions text-center">
                              <button class="all-btn edit-btn table-action" data-original-title="Edit" @click="showEmploymentCoefficientFieldModal(result)">
                                  <i class="fa fa-edit"></i>
                              </button>
                              <button class="all-btn delete-btn table-action" @click="deleteField(result.id)">
                                  <i class="fa fa-remove"></i>
                              </button>
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <RealEstateEmploymentCoefficientFieldEditModal></RealEstateEmploymentCoefficientFieldEditModal>
    </div>
</template>

<script>
    import initFilterModel from '@/shared/filter';
    import RealEstateEmploymentCoefficientFieldEditModal from './RealEstateEmploymentCoefficientFieldEditModal'
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';

    export default {
        components: {
            RealEstateEmploymentCoefficientFieldEditModal,
            'b-pagination': bPagination
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('real-estate/employment/coefficient/field/list',this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    },err => {
                        this.loading = false;
                        console.log(err)
                    });
            },
            showEmploymentCoefficientFieldModal(data) {
                this.$eventBus.$emit('showEmploymentCoefficientFieldModal',data)
            },
            deleteField(id) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('messages.realEstate.employmentCoefficientField.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('real-estate/employment/coefficient/field/' + id)
                            .then((res) => {
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('messages.realEstate.employmentCoefficientField.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.initList();
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: res.data.message,
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.realEstate.employmentCoefficientField.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    }
                });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('employmentCoefficientFieldChange', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>